import React, { useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';

function FiltersConfig() {

     const [selectedCities, setSelectedCities] = useState(null);
        const countries = [
            { name: 'Zambia', code: 'ZM' },
        ];
        const provinces = [
            { name: 'Luapula', code: 'ZM' },
            { name: 'Northern', code: 'ZM' },
        ];
        const districts = [
            { name: 'Kasama', code: 'ZM' },
            { name: 'Lupososhi', code: 'ZM' },
            { name: 'Luwingu', code: 'ZM' },
            { name: 'Mungwi', code: 'ZM' },
        ];
        const villages = [
            { name: 'Chifwile', code: 'ZM' },
            { name: 'Chitunkubwe', code: 'ZM' },
            { name: 'Chimba', code: 'ZM' },
            { name: 'Chishika', code: 'ZM' },
            { name: 'Kondam', code: 'ZM' },
        ];

        const meteorologicalWeeks = [
            { id: 1, name: 'Meteorological Week 1 - Early Spring' },
            { id: 2, name: 'Meteorological Week 2 - Late Spring' },
            { id: 3, name: 'Meteorological Week 3 - Early Summer' },
            { id: 4, name: 'Meteorological Week 4 - Mid-Summer' },
            { id: 5, name: 'Meteorological Week 5 - Late Summer' },
            { id: 6, name: 'Meteorological Week 6 - Early Autumn' },
            { id: 7, name: 'Meteorological Week 7 - Mid-Autumn' },
            { id: 8, name: 'Meteorological Week 8 - Late Autumn' },
            { id: 9, name: 'Meteorological Week 9 - Early Winter' },
            { id: 10, name: 'Meteorological Week 10 - Mid-Winter' }
          ];

  return (
      <>
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="filter-box pt-3">
                            <h5>Selection</h5>
                            <div className="form-group">
                                <label htmlFor="">Country</label>
                                <MultiSelect value={selectedCities} onChange={(e) => setSelectedCities(e.value)} options={countries} optionLabel="name"
                                    placeholder="Select" maxSelectedLabels={3} className="w-100" />
    
                                {/* <select className="form-select custom-select">
                                    <option>Select</option>
                                </select> */}
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Province</label>
                                <MultiSelect value={selectedCities} onChange={(e) => setSelectedCities(e.value)} options={provinces} optionLabel="name"
                                    placeholder="Select" maxSelectedLabels={3} className="w-100" />
    
                                {/* <select className="form-select custom-select">
                                    <option>Select</option>
                                </select> */}
                            </div>
                            <div className="form-group">
                                <label htmlFor="">District</label>
                                <MultiSelect value={selectedCities} onChange={(e) => setSelectedCities(e.value)} options={districts} optionLabel="name"
                                    placeholder="Select" maxSelectedLabels={3} className="w-100" />
    
                                {/* <select className="form-select custom-select">
                                    <option>Select</option>
                                </select> */}
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Camp</label>
                                <MultiSelect value={selectedCities} onChange={(e) => setSelectedCities(e.value)} options={villages} optionLabel="name"
                                    placeholder="Select" maxSelectedLabels={3} className="w-100" />
    
                                {/* <select className="form-select custom-select">
                                    <option>Select</option>
                                </select> */}
                            </div>

                            <div className="form-group">
                                <label htmlFor="">Species</label>
                                <MultiSelect value={selectedCities} onChange={(e) => setSelectedCities(e.value)} options={villages} optionLabel="name"
                                    placeholder="Select" maxSelectedLabels={3} className="w-100" />
    
                                {/* <select className="form-select custom-select">
                                    <option>Select</option>
                                </select> */}
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="">Meteorological Week*</label>
                                <MultiSelect value={selectedCities} onChange={(e) => setSelectedCities(e.value)} options={meteorologicalWeeks} optionLabel="name"
                                    placeholder="Select" maxSelectedLabels={3} className="w-100" />
    
                                {/* <select className="form-select custom-select">
                                    <option>Select</option>
                                </select> */}
                            </div>
                            {/* <div className="form-group">
                                <label htmlFor="">Village</label>
                                <select className="form-select">
                                    <option>Select</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Village</label>
                                <select className="form-select">
                                    <option>Select</option>
                                </select>
                            </div> */}
    
                            <div className="btn btn-submit w-100 mt-15px">Submit</div>
                        </div>
                    </div>
                </div>
            </>
  )
}

export default FiltersConfig